import React, { FC } from 'react';

import { EquipmentLocation, PaidInstallation } from '@app/api/models/equipment';
import { useFetchData, useApi } from '@app/hooks';
import { QueryTable } from '@app/components/common/table';

import { columns } from './columns';

const PaidInstallationsTable: FC = () => {
  const api = useApi();
  const [fetchData] = useFetchData<PaidInstallation>({ method: api.equipments.getPaidInstallations });

  return (
    <>
      <QueryTable<PaidInstallation>
        title="Платные установки"
        columns={columns}
        fetchData={fetchData}
        canDownload
      />
    </>
  );
};

export default PaidInstallationsTable;
